import { styled } from '@mui/material/styles'
import { MaterialDesignContent } from 'notistack'

export const StyledSnackbar = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: ({ theme }) => theme.palette.success.main,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: ({ theme }) => theme.palette.error.main,
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: ({ theme }) => theme.palette.warning.main,
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: ({ theme }) => theme.palette.info.main,
  },
}))
